// material
import { CircularProgress, Box, Stack, Skeleton } from '@mui/material'
// redux
import NoNotifications from 'pages/NoNotifications'
import { UIContractState as Guarantee } from '../../@types/UIContractState'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'routes/paths'
import Page from 'components/Page'
import { Table, TableContainer } from './styles/MyTasks.styles'
import TaskCounter from './TaskCounter'
import HeadingTitle from './HeadingTitle'
import { useOrgTasks } from 'hooks/useOrgTasks'
import { fDateWithTimeZone } from 'utils/formatTime'
import { displayUserReadableAmount } from 'components/request-action/sections/forms/utils'

// Skeleton loader for org tasks table
const OrgTasksSkeleton = () => (
  <Box sx={{ p: 2 }}>
    <Stack spacing={2}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gap: 2,
            p: 2,
            backgroundColor: '#f9f9f9',
            borderRadius: 1,
            border: '1px solid #e0e0e0'
          }}
        >
          {Array.from({ length: 6 }).map((_, colIndex) => (
            <Skeleton key={colIndex} variant="text" width="100%" height={16} />
          ))}
        </Box>
      ))}
    </Stack>
  </Box>
)

// ----------------------------------------------------------------------

export default function OrgTasks() {
  const navigate = useNavigate()
  const { orgTasks, isLoading } = useOrgTasks()

  return (
    <Page title="Organisation Tasks" sx={{ margin: '0 24px 0 18px', paddingTop: '8px' }}>
      {isLoading && (
        <OrgTasksSkeleton />
      )}
      <Box sx={{ marginBottom: '18px' }}>
        <HeadingTitle>Organisation Tasks</HeadingTitle>
      </Box>
      <Box sx={{ marginBottom: '18px' }}>
        <TaskCounter type="org-task" rows={orgTasks} />
      </Box>
      {orgTasks && orgTasks?.length > 0 && (
        <TableContainer>
          <Table>
            <thead>
              <tr>
                <th>Request Type</th>
                <th>Guarantee ID</th>
                <th>Requested By</th>
                <th>Currency</th>
                <th>Value</th>
                <th>Request Date</th>
              </tr>
            </thead>
            <tbody>
              {orgTasks?.length > 0 &&
                orgTasks?.map((row: Guarantee) => (
                  <tr
                    key={row?.TriContractState?.contractIdentifier}
                    onClick={() =>
                      navigate(
                        `${PATH_DASHBOARD.general.guarantee}/${row?.TriContractState?.contractIdentifier}`
                      )
                    }
                  >
                    <td>{row.organizationTask?.requestType}</td>
                    <td>{row?.TriContractState?.contractIdentifier}</td>
                    <td>{row?.organizationTask?.createdBy}</td>
                    <td>{row?.TriContractState?.amount?.currencyCode}</td>
                    <td>
                      {row?.TriContractState?.amount &&
                        displayUserReadableAmount(row?.TriContractState?.amount)}
                    </td>
                    <td>
                      {row?.organizationTask?.requestDate?.includes('UTC' || 'utc')
                        ? fDateWithTimeZone(row?.organizationTask?.requestDate)
                        : row?.organizationTask?.requestDate}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </TableContainer>
      )}
      {!isLoading && orgTasks?.length === 0 && (
        <NoNotifications title="No Org Tasks" type="organisation tasks" />
      )}
    </Page>
  )
}
